import { flowRight as compose } from 'lodash';

import dataView from '~lib/common/hoc/dataView';
import renameProps from '~lib/common/hoc/renameProps';
import withUser from '~lib/common/hoc/withUser';

import CaseAvatar from './CaseAvatar.vue';
import avatarQueries from '~lib/common/queries/Avatar';
import voiceQueries from '~lib/common/queries/Voice';

const enhance = compose(
  dataView({ queries: avatarQueries }),
  renameProps({ data: 'avatars' }),
  dataView({ queries: voiceQueries }),
  renameProps({ data: 'voices' }),
  withUser()
);

export default enhance(CaseAvatar);
